import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styles from './Header.module.css';
import { NotificationBell } from './NotificationBell.tsx';
import { useNotificationSSE } from '../hooks/useNotifications';
import { DarkModeToggle } from './DarkModeToggle';
import { useDarkMode } from '../contexts/DarkModeContext';
import { Search } from 'lucide-react';
import SearchModal from './SearchModal';

export default function Header() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { isDarkMode } = useDarkMode();

  useNotificationSSE();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className={`shadow-md transition-colors duration-200 ${
      isDarkMode ? 'bg-gray-800' : 'bg-green-800'
    }`}>
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className={styles.caveatTitle}>
            Hike Rank
          </Link>

          <div className="hidden md:flex space-x-6 items-center">
            <Link to="/top" className="text-white hover:text-green-200">
              Top Hikes
            </Link>
            <Link to="/users" className="text-white hover:text-green-200">
              Community
            </Link>
            {isAuthenticated ? (
              <>
                <Link to="/my-list" className="text-white hover:text-green-200">
                  My List
                </Link>
                <Link to="/timeline" className="text-white hover:text-green-200">
                  Timeline
                </Link>
                <Link to="/friends" className="text-white hover:text-green-200">
                  Friends
                </Link>
                <Link to="/resources" className="text-white hover:text-green-200">
                  Resources
                </Link>
                <Link to="/my-account" className="text-white hover:text-green-200">
                  My Account
                </Link>
              </>
            ) : (
              <>
                <Link to="/login" className="text-white hover:text-green-200">
                  Login
                </Link>
                <Link to="/register" className="text-white hover:text-green-200">
                  Register
                </Link>
              </>
            )}
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => setIsSearchOpen(true)}
              className="text-white hover:text-green-200"
            >
              <Search className="h-5 w-5 md:h-5 md:w-5" />
            </button>
            {isAuthenticated && <NotificationBell />}
            <DarkModeToggle />
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-white hover:text-green-200"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 space-y-4 text-right pr-4">
            <Link
              to="/top"
              className="block text-white hover:text-green-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Top Hikes
            </Link>
            <Link
              to="/users"
              className="block text-white hover:text-green-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Community
            </Link>
            {isAuthenticated ? (
              <>
                <Link
                  to="/my-list"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  My List
                </Link>
                <Link
                  to="/timeline"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Timeline
                </Link>
                <Link
                  to="/friends"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Friends
                </Link>
                <Link
                  to="/resources"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Resources
                </Link>
                <Link
                  to="/my-account"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  My Account
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMobileMenuOpen(false);
                  }}
                  className="block w-full text-right text-white hover:text-green-200"
                >
                  Log Out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="block text-white hover:text-green-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Register
                </Link>
              </>
            )}
          </div>
        )}
      </nav>

      <SearchModal
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />
    </header>
  );
}
